import { paymentOrderStatus, paymentTransactionStatus } from '@containers/App/app.constant';
import { parseDateTime } from '@utils/dateHelpers';
import { PREV_ORDER_ID, RBS_IN_QUERY, localStorageSetItem } from '@utils/localStorageHelpers';
import { validateRescheduleAction, validateSlotAction } from '@utils/slotHelper';
import formatString from '@utils/stringHelper';
export function convertTimeToMinutes(timeStr) {
    if (!timeStr)
        return null;
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        throw new Error('Invalid time format. Expected HH:MM:SS');
    }
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalSeconds / 60;
}
export function getHostnameWithEndpoint() {
    const hostname = typeof window !== 'undefined' && window.location ? window.location.hostname : '';
    const endpoint = hostname.includes('.pr-')
        ? 'https://supergraph.talview.com/v1/graphql'
        : 'https://api.talview.com/v1/graphql';
    return { hostname, endpoint };
}
export function convertTimeToSeconds(timeStr) {
    if (!timeStr)
        return null;
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        throw new Error('Invalid time format. Expected HH:MM:SS');
    }
    return hours * 3600 + minutes * 60 + seconds;
}
export function secondsToTimeString(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
}
// todo(atul): below convertTimeToSeconds is better function it handles edge case!
// export function convertTimeToSeconds(timeInput: string | number): number | null {
//   if (timeInput === null || timeInput === undefined) return null;
//   // If already a number
//   if (typeof timeInput === 'number') {
//     return timeInput;
//   }
//   const timeStr = timeInput.trim();
//   // If pure digits (e.g., "2400")
//   if (/^\d+$/.test(timeStr)) {
//     return Number(timeStr);
//   }
//   const parts = timeStr.split(':');
//   if (parts.length === 2) {
//     // Assume it's MM:SS, auto-fix to 00:MM:SS
//     parts.unshift('00');
//   }
//   if (parts.length !== 3) {
//     console.error(`Invalid time format: "${timeStr}". Expected HH:MM:SS`);
//     return null;
//   }
//   const [hoursStr, minutesStr, secondsStr] = parts;
//   const hours = Number(hoursStr);
//   const minutes = Number(minutesStr);
//   const seconds = Number(secondsStr);
//   if ([hours, minutes, seconds].some(isNaN)) {
//     console.error(`Invalid time format: "${timeStr}". Expected HH:MM:SS`);
//     return null;
//   }
//   return hours * 3600 + minutes * 60 + seconds;
// }
export function formatDuration(duration) {
    if (!duration) {
        return '';
    }
    const [hours, minutes, seconds] = duration.split(':').map(Number);
    const formattedHours = hours > 0 ? `${hours} hour${hours > 1 ? 's' : ''}` : '';
    const formattedMinutes = minutes > 0 ? `${minutes} minute${minutes > 1 ? 's' : ''}` : '';
    const formattedSeconds = seconds > 0 ? `${seconds} second${seconds > 1 ? 's' : ''}` : '';
    // Filter out empty parts and join them with a space
    return [formattedHours, formattedMinutes, formattedSeconds].filter(Boolean).join(' ');
}
export function formatDateRange(start_date, end_date) {
    // Create DateTime objects from ISO date strings
    const startDate = parseDateTime(start_date);
    const endDate = parseDateTime(end_date);
    // Check if both dates are valid
    if (!startDate || !endDate) {
        return '';
    }
    // Format both dates
    const startDateFormatted = startDate.toFormat('d MMM yyyy');
    const endDateFormatted = endDate.toFormat('d MMM yyyy');
    // Return the formatted date range
    return `${startDateFormatted} - ${endDateFormatted}`;
}
export const SUPPORT_TICKET_URL = 'https://talview.freshdesk.com/support/tickets/new';
export const isSafari = () => {
    const ua = navigator.userAgent;
    return /^((?!chrome|android).)*safari/i.test(ua);
};
export const isIOS = () => {
    const ua = navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua) && !window?.MSStream;
};
export const startsWithHttp = (url) => /^http/.test(url);
export const getPaymentCompleted = (paymentDetails) => formatString(paymentDetails?.order_status || '') === formatString(paymentOrderStatus.COMPLETED) &&
    formatString(paymentDetails?.transactionDetails?.transactionStatus || '') ===
        formatString(paymentTransactionStatus.COMPLETED);
export const getPaymentPending = (paymentDetails) => {
    const orderStatus = formatString(paymentDetails?.order_status ?? '');
    const transactionStatus = formatString(paymentDetails?.transactionDetails?.transactionStatus ?? '');
    const isPendingOrder = orderStatus === formatString(paymentOrderStatus.PAYMENT_PENDING);
    const isPendingTransaction = [
        formatString(paymentTransactionStatus.PENDING),
        formatString(paymentTransactionStatus.INITIATED),
    ].includes(transactionStatus);
    return isPendingOrder && isPendingTransaction;
};
export const handlePayAndBookReschedule = ({ driveFrom, orderId, prevOrderId, slotRescheduleCutoffTime, isPayAndBook, isPaymentCompleted, showUnAuthAccessScreen, navigate, redirectFrom = 'slotBooking-rescheduled-rule', }) => {
    if (!validateSlotAction(driveFrom, slotRescheduleCutoffTime)) {
        showUnAuthAccessScreen?.();
        return true;
    }
    if (isPayAndBook && validateRescheduleAction(driveFrom ?? '') && !isPaymentCompleted) {
        localStorageSetItem(PREV_ORDER_ID, JSON.stringify(prevOrderId || ''));
        localStorageSetItem(RBS_IN_QUERY, 'true');
        navigate(`/payment/details?order_id=${orderId ?? prevOrderId}`, {
            replace: true,
            state: {
                isPayAndBook,
                from: redirectFrom,
            },
        });
        return true;
    }
    return false;
};
